const NON_DOC_WORKSPACE_ROUTE_SEGMENTS = new Set([
  'all',
  'chat',
  'collection',
  'graph-explorer',
  'journals',
  'mail',
  'marketplace',
  'app-bases',
  'settings',
  'tag',
  'trash',
  'workflows',
]);

function trimLeadingSlash(path: string): string {
  return path.startsWith('/') ? path.slice(1) : path;
}

export function workspaceRouteRequiresPermissionCache(
  pathname: string,
  workspaceId: string
): boolean {
  const workspacePrefix = `/workspace/${workspaceId}`;
  if (
    pathname !== workspacePrefix &&
    !pathname.startsWith(`${workspacePrefix}/`)
  ) {
    return true;
  }

  const relativePath = trimLeadingSlash(pathname.slice(workspacePrefix.length));
  if (!relativePath) return false;

  const [firstSegment] = relativePath.split('/');
  if (NON_DOC_WORKSPACE_ROUTE_SEGMENTS.has(firstSegment)) return false;

  // Direct doc routes still enforce Doc_Read in DetailPage/GuardService.
  // The workspace shell itself must remain local-first and paint without a
  // server-populated permission list.
  return false;
}
